<template>
  <div>
    <InvoiceList :items="formData.transactions" />

    <div v-if="formData?.invoice !== null" class="mb-10">
      <UploadedInvoice :invoice="formData.invoice" />
    </div>

    <div class="mb-10">
      <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
        Cuenta en la que vas a recibir el pago
      </h6>
      <v-card
        v-if="cbuAccountSelected"
        class="d-flex flex-column"
        elevation="0"
      >
        <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
          >Nombre y Apellido:
          <span class="font-weight-regular"
            >{{ cbuAccountSelected.nombre_prestador }}
            {{ cbuAccountSelected.apellido_prestador }}</span
          ></span
        >
        <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
          >CUIT:
          <span class="font-weight-regular">{{
            cbuAccountSelected.cuit
          }}</span></span
        >
        <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
          >Banco:
          <span class="font-weight-regular">{{
            cbuAccountSelected.banco
          }}</span></span
        >
        <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
          >CBU:
          <span class="font-weight-regular">{{
            cbuAccountSelected.cbu
          }}</span></span
        >
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import InvoiceList from "../InvoiceList.vue";
import UploadedInvoice from "../UploadedInvoice.vue";

export default {
  name: "ThirdStep",
  components: {
    InvoiceList,
    UploadedInvoice,
  },
  props: ["formData", "v"],
  data: () => ({}),
  computed: {
    ...mapState("invoice", ["technicianAccounts"]),
    ...mapGetters("invoice", ["cbuAccountSelected"]),
  },
  methods: {},
};
</script>

<style scoped>
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
th,
td {
  border-bottom: none !important;
}
</style>
